// Chiffres de marque centralisés pour garantir un affichage harmonisé partout.
// Audience cumulée des groupes Facebook locaux animés par PROXIreduc-28.
export const FB_MEMBERS_TOTAL = 120000;
export const FB_MEMBERS_DISPLAY = "120 000";
export const FB_MEMBERS_LABEL = "120 000 membres en cumulé";
